import { PaymentHistory } from "@app/models/PaymentHistory";
import { Property } from "@app/models/Property";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PaymentHistoryApi } from "@app/services/apiServices/PaymentHistoryApi";
import { SpinnerService } from "@app/services/spinner.service";
import { take } from "rxjs/operators";
import { Component, Inject } from "@angular/core";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { ActivatedRoute, Router } from "@angular/router";

/**
 * Created by mac85103 on 11/28/16.
 */
@Component({
    selector: 'app-payment-history-component',
    template: require('./paymentHistory.html')
})
export class PaymentHistoryComponent {
    paymentHistory: PaymentHistory[];
    propertyId: string;
    property: Property;
    $stateParams: any;

    constructor(
        @Inject(PropertyApi) private propertyApi,
        @Inject(PaymentHistoryApi) private paymentHistoryApi: PaymentHistoryApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute
    ) {

        this.propertyId = this.route.snapshot.params.propertyId;

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }

        this.getPaymentHistories(this.route.snapshot.params.propertyId);

        if (this.$stateParams && this.$stateParams.property) {
            this.property = this.$stateParams.property;
        } else {
            this.getProperty(this.propertyId);
        }

    }

    getPaymentHistories(propertyId) {
        // Get the payment histories for this property by propertyId
        if (propertyId) {
            this.propertyId = propertyId;
            this.spinnerService.showSpinner();
            this.paymentHistoryApi.propertiesIdPaymentHistoriesGet(propertyId)
                .pipe(take(1)).subscribe({ next: (resp) => {

                    this.paymentHistory = resp;
                    this.spinnerService.closeSpinner();

                }, error: (err) => {
                    this.networkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.getPaymentHistories(propertyId);
                            }
                        });
                } });
        }  else {
            this.router.navigateByUrl('/properties');
        }
    }

    goBack() {
        this.router.navigateByUrl('/properties');
    }

    private getProperty(propertyId: string) {
        this.propertyApi.propertiesIdGet(Number(propertyId))
            .pipe(take(1)).subscribe({ next: resp => {
                this.property = resp;
            }, error: () => {} });
    }
}

